// services/apiClient.ts
import axios from "axios";
import { getStoredToken, clearStoredToken } from "./authService";
import { API_BASE_URL } from "../config";

// Create axios instance
const apiClient = axios.create({
    baseURL: API_BASE_URL,
});

// Request interceptor to add token to all requests
apiClient.interceptors.request.use(
    (config) => {
        const token = getStoredToken();

        // Add token to headers if it exists
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle auth errors
apiClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // If we get a 401, clear the stored token
        if (error.response?.status === 401) {
            clearStoredToken();
        }

        return Promise.reject(error);
    }
);

export default apiClient;
